<template>
	<v-autocomplete
		v-model="device"
		v-bind="$attrs"
		v-model:search="searchInput"
		chips
		hide-no-data
		item-title="full_name"
		item-value="id"
		:items="devices"
		:loading="searchLoading"
		@update:model-value="selectDevice"
	/>
</template>

<script>
import {
	debounce, sample,
} from 'lodash';
import axios from 'axios';

export default {
	name: 'DeviceNameSearch',

	props: {
		endpoint: {
			type: String,
			default: '/bo/orders/devices'
		},
		initialiseValue: {
			type: Boolean,
			default: false
		}
	},

	emits: ['input', 'select',],

	data () {
		return {
			devices: [],
			searchLoading: false,
			searchInput: '',
			device: null
		};
	},

	watch: {
		/**
		 * @param {string} search
		 * @returns {void}
		 */
		searchInput: debounce(function (search) {
			if (search && this.searchInput) {
				this.searchDevices(search);
			}
		}, 500),
	},

	mounted () {
		if (this.initialiseValue) {
			this.searchDevices('').then(() => {
				if (this.devices.length > 0) {
					this.device = sample(this.devices, 1);
					this.$emit('input', this.device.id);
				}
			});
		}
	},

	methods: {
		/**
		 * This function gets relevant devices from the devicedb based on the user's search
		 *
		 * @param {string} search
		 * @returns {Promise}
		 */
		searchDevices (search) {
			return new Promise((resolve) => {
				this.searchLoading = true;
				axios
					.get(this.endpoint, {
						params: {
							'search': search,
						},
					})
					.then(({
						data: devices,
					}) => {
						this.searchLoading = false;
						devices.sort((a, b) => {
							return a.full_name >= b.full_name ? 1 : -1;
						});
						this.devices = devices;
						resolve();
					})
					.catch((error) => {
						this.searchLoading = false;
						this.displayError(this.$gettext('Unable to get devices'));
						window.captureException(error);
						resolve();
					});
			});
		},

		/**
		 * @param {number} deviceId
		 * @returns {void}
		 */
		selectDevice (deviceId) {
			const device = this.devices.find((e) => e.id === deviceId);

			if (device) {
				this.$emit('select', device.full_name);
			}
			this.$emit('input', deviceId);
		},

		/**
		 * Clear autocomplete props
		 *
		 * @returns {void}
		 */
		reset () {
			this.devices = [];
			this.searchLoading = false;
			this.searchInput = '';
		}
	}
};
</script>
